import { useMemo } from "react";
import { useSelector } from "react-redux";

import ApiClientAsync from "../api/ApiClientAsync";
import { getAuthToken } from "../redux/modules/auth/login/selector";
import { getLocale } from "../redux/modules/translations/selector";

/**
 * ApiClientAsync for the current locale and auth token.
 * Identity changes only when those values change.
 */
export default function useClient() {
  const locale = useSelector(getLocale);
  const authToken = useSelector(getAuthToken);

  return useMemo(
    () => new ApiClientAsync(locale, authToken),
    [locale, authToken]
  );
}
